<template>
  <v-autocomplete
    v-model="branchFilterArray"
    :items="items"
    :label="this.$t('cards.branches')"
    item-text="name"
    item-value="branchId"
    single-line
    :prepend-icon="'mdi-source-branch'"
    @click:append="clear()"
    :append-icon="'mdi-close'"
    :allow-overflow="false"
    :search-input.sync="search"
    :disabled="isDisabled"
    return-object
  >
    <template v-slot:item="{ item }">
      <span>{{ item.name }}</span>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: ['branchFilterValue', 'bankFilterArray', 'disabled'],
  model: {
    prop: 'branchFilterValue',
    event: 'branchFilterValueEv',
  },
  data() {
    return {
      searchFuncRunned: false,
      search: null,
      searchArr: [],
      lastActiveDate: null,
      branchFilterArray: [], // filterValue
      branches: [], // branches by selected banks
      banksByBranches: [], // selected banks after select branch
    };
  },
  computed: {
    items() {
      if (!this.searchArr || this.searchArr.length == 0) return this.branches;

      return this.searchArr;
    },
    isDisabled() {
      return (
        this.disabled ||
        (this.branchFilterArray &&
          this.branchFilterArray.length != 0 &&
          this.items.length === 1)
      );
    },
  },
  mounted() {},
  watch: {
    async search() {
      this.lastActiveDate = Date.now();

      if (!this.searchFuncRunned) {
        this.searchFuncRunned = true;
        setTimeout(this.runSearch, 500);
      }
    },
    bankFilterArray: async function() {
      if (!this.bankFilterArray || this.bankFilterArray.length == 0) {
        this.clear();

        return;
      }
      this.dropBanksByBranchesId();
      this.updateBranches();
    },
    branchFilterValue() {
      this.branchFilterArray = this.branchFilterValue;
    },
    branchFilterArray() {
      this.$emit('branchFilterValueEv', this.branchFilterArray);
    },
    branches() {
      if (
        this.branches &&
        this.branches.length > 0 &&
        this.branchFilterArray &&
        this.branchFilterArray.length !== 0 &&
        this.branches.find(
          (branch) => branch.branchId === this.branchFilterArray.branchId
        ) === undefined
      ) {
        if (this.branches.length === 1)
          this.branchFilterArray = this.branches[0];
        else this.branchFilterArray = [];
      }
    },
  },
  methods: {
    dropBanksByBranchesId() {
      this.banksByBranches = this.banksByBranches.filter(
        (id) =>
          this.bankFilterArray.find((bank) => bank.bankId === id) !== undefined
      );
    },
    dropFromBrFiltArr() {
      // drop non actual branches from filter
      if (
        this.branchFilterArray &&
        this.bankFilterArray.find(
          (bank) => this.branchFilterArray.bankId === bank.bankId
        ) === undefined
      )
        this.clear();
    },
    updateBranches() {
      this.dropFromBrFiltArr();
      this.removeOldBranches();

      this.getAndSetNewBranches();
    },
    getAndSetNewBranches() {
      const newBanksId = this.getNewBanks();
      if (!newBanksId || newBanksId.length === 0) return;

      this.setNewBranchesByBanksId(newBanksId);
    },
    removeOldBranches() {
      // remove branches, if banks removed from filter
      this.branches = this.checkBranchArrByBanksFilter(this.branches);
    },
    getNewBanks() {
      var newBanksId = [];
      const len = this.bankFilterArray.length;

      for (var i = 0; i < len; i++) {
        const bankId = this.bankFilterArray[i].bankId;

        const isSelectedBank =
          this.branchFilterArray && this.branchFilterArray.bankId === bankId;

        if (!isSelectedBank || !this.branches || this.branches.length === 0) {
          newBanksId.push(bankId);
          this.banksByBranches.push(bankId);
        }
      }

      return newBanksId;
    },
    setNewBranchesByBanksId(banksId) {
      if (!banksId || banksId.length === 0) return;

      this.$axios.branches
        .getByBanksArrayForDevices(banksId)
        .then((response) => response.data)
        .then((json) => {
          this.branches = this.branches.concat(json);
          if (this.branches.length === 1)
            this.branchFilterArray = this.branches[0];
        });
    },
    addBranchesToBranchFilterArray(newBranches) {
      // new branches after selected banks
      const branches = newBranches.filter(
        (branch) =>
          this.banksByBranches.find((bankId) => branch.bankId === bankId) ===
          undefined
      );

      if (branches !== undefined)
        this.branches = this.branches.concat(branches);
    },
    checkBranchArrByBanksFilter(branchArr) {
      return branchArr.filter(
        (branchInfo) =>
          this.bankFilterArray.find(
            (bank) => bank.bankId === branchInfo.bankId
          ) !== undefined
      );
    },

    async runSearch() {
      let dif;
      do {
        dif = Date.now() - this.lastActiveDate;
      } while (dif < 500);

      this.searchFuncRunned = false;

      if (!this.search || this.search.length === 0) this.searchArr = [];
      else
        await this.searchBranchesForFilter(this.search).then(
          (data) => (this.searchArr = data)
        );
    },
    async searchBranchesForFilter(val) {
      if (
        this.bankFilterArray === undefined ||
        this.bankFilterArray === null ||
        this.bankFilterArray.length === 0
      )
        return this.searchByAllBranches(val);
      else return this.searchByBranches(val);
    },
    async searchByAllBranches(val) {
      const params = {
        query: JSON.stringify({ branchName: !val ? '' : val }),
        limit: 10,
        offset: 0,
      };
      let res;

      await this.$axios.cards
        .branches(params)
        .then((response) => response.data)
        .then((json) => (res = json.slice(0, 10)));

      return res;
    },
    async searchByBranches(val) {
      if (this.branchFilterArray && this.branchFilterArray.name === val)
        return [];

      var res = this.branches.filter((branch) => {
        return branch.name.includes(val);
      });

      if (res === undefined) return [];

      return res;
    },
    clear() {
      this.branchFilterArray = [];
      this.search = '';
      if (
        !this.bankFilterArray ||
        this.bankFilterArray.length === 0 ||
        (this.branchFilterArray &&
          this.branchFilterArray.length !== 0 &&
          this.bankFilterArray.find(
            (bank) => this.branchFilterArray.bankId === bank.bankId
          ) === undefined)
      ) {
        this.branches = [];
        this.banksByBranches = [];
      }
    },
  },
};
</script>
